import React, { Fragment, useState, useEffect, Component } from "react";
import { connect } from "react-redux";
import { Link, Route, Router, Switch } from "react-router-dom";
import { Pagination, Responsive } from "semantic-ui-react";

import AdminWrapper from "../AdminWrapper";
import SwitchMenuBar from "../../../Components/SwitchMenuBar/SwitchMenuBar";
import SearchBar from "../../../Components/SearchBar/SearchBar";

import { API } from "../../../API";
import {
  getTotalPages,
  extractDataOfCurrPage,
} from "../../../Helper/PagingHelper";
import { populateCollegeData } from "../../../Helper/CollegeHelper";
import { updateCurrentCollegeDetails } from "../../../redux/admin/admin.actions";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import { notify } from "react-notify-toast";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import Modal from "../../../Components/Modal/Modal";
import moment from "moment";

// Define constant values
const ROW_PER_PAGE = 10;

const AllColleges = ({ history, updateCurrentCollegeDetails, props }) => {
  const [allCustomers, setAllCustomers] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [customersOfCurrPage, setCustomersOfCurrPage] = useState([]);
  const [showConfirmChangeGroupPopup, setShowConfirmChangeGroupPopup] = useState(false);
  const [institutionId, setInstitutionId] = useState('');
  const [group, setGroup] = useState('');

  useEffect(() => {
    getAllCustomers();
  }, []);

  const dateFromObjectId = (objectId) => {
    return new Date(parseInt(objectId.substring(0, 8), 16) * 1000);
  };

  const getAllCustomers = () => {
    API.allCustomers()
      .then((result) => {
        const customers = result.data
          // .filter((cus) => cus.institution_id && cus.secret_answer1 !== "")
          .sort((a, b) => {
            let dateA = dateFromObjectId(a._id);
            let dateB = dateFromObjectId(b._id);
            return dateB - dateA;
          })
          .map((cus) => {
            if (cus.institution_name) return cus;
            else {
              return {
                ...cus,
                institution_name: cus?.institution_id?.institution_name || ""
              }
            }
          })
        setAllCustomers(customers);
        setFilteredCustomers(customers);
        calculatePageCount(customers);
        extractCustomersOfCurrPage(pageNum, customers);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const calculatePageCount = (customers) => {
    const pageCount = getTotalPages(customers, ROW_PER_PAGE);
    setTotalPages(pageCount);
  };

  const customerDataChangedCallback = async (customerList) => {
    setCustomersOfCurrPage(customerList);
  };

  const extractCustomersOfCurrPage = (pageNumber, customers) => {
    extractDataOfCurrPage(
      pageNumber,
      customers,
      ROW_PER_PAGE,
      customerDataChangedCallback,
      setPageNum
    );
  };

  const updatePagingData = (filteredData) => {
    setPageNum(1);
    setFilteredCustomers(filteredData);
    calculatePageCount(filteredData);
    extractCustomersOfCurrPage(1, filteredData);
  };

  const searchByName = (e) => {
    let searchItem = e.target.value.toLowerCase();

    if (searchItem.length > 0) {
      if (allCustomers.length > 0) {
        let filteredData = allCustomers.filter((c) =>
          c.first_name === undefined ||
            c.last_name === undefined ||
            c.email === undefined ||
            c.mobile === undefined ||
            c.institution_name === undefined
            ? false
            : filterCriteria(c).includes(searchItem)
        );

        updatePagingData(filteredData);
      }
    } else {
      updatePagingData(allCustomers);
    }
  };

  const onPageNumChange = (e) => {
    extractCustomersOfCurrPage(
      e.target.getAttribute("value"),
      filteredCustomers
    );
  };

  const filterCriteria = (c) => {
    let results = "";

    if (c.first_name) results += c.first_name;
    if (c.last_name) results += c.last_name;
    if (c.email) results += c.email;
    if (c.mobile) results += c.mobile;

    if (c.institution_name) results += c.institution_name;
    if (c.institution_id) {
      if (c.institution_id.inst_shortname)
        results += c.institution_id.inst_shortname;
      if (c.institution_id.extra_booking_email)
        results += c.institution_id.extra_booking_email;
      if (c.institution_id.institution_name)
        results += c.institution_id.institution_name;
    }

    return results.toLowerCase();
  };

  const getContactName = (first_name, last_name) => {
    let result = "";

    if (first_name) {
      result += first_name + " ";
    }

    if (last_name) {
      result += last_name;
    }

    return result;
  };

  const buildTableHeader = (headerName) => {
    return <th className="availability-table-head-cell">{headerName}</th>;
  };

  const bindTableData = (data) => {
    return <td className="availability-table-cell">{data}</td>;
  };

  const bindTableDataWithId = (value, id, data) => {
    return (
      <td value={value} id={id} className="availability-table-cell">
        {data}
      </td>
    );
  };

  const buildProfileLocation = (customer) => {
    let location = null;

    if (customer.institution_id) {
      location = {
        pathname: `/NavigateToCollegeSharedProfile?id=${customer.institution_id._id}`,
      };
    }
    return location;
  };

  const bindProfileLink = (customer) => {
    const location = buildProfileLocation(customer);
    return (
      <td className="availability-table-cell">
        {location && customer.institution_id?._id && (
          <Link
            className="mdi mdi-account-circle-outline home-icon-margin-adjust profile-link"
            to={location}
            target="_blank"
          ></Link>
        )}
      </td>
    );
  };

  const bindContractSignedInfoData = (customer) => {
    const signedDate = customer?.institution_id?.new_pricing_contract?.signed_date  ?? customer?.institution_id?.new_pricing_contract?.signed_date ?? customer?.institution_id?.contract?.signed_date
    let formatSignedDate = ""
    if (signedDate) {
      const targetDate = moment.utc().month(3).date(7).endOf('day'); // 07/04
      if (moment.utc(signedDate).isBefore(targetDate, 'day')) {
        formatSignedDate = `${moment.utc(signedDate).tz('Australia/Sydney').format("DD-MM-YYYY HH:mm:ss") + " (AEDT)"}`
      } else {
        formatSignedDate = `${moment.utc(signedDate).tz('Australia/Brisbane').format("DD-MM-YYYY HH:mm:ss") + " (AEST)"}`
      }
    }

    const fullName = customer?.institution_id?.new_pricing_contract?.full_name
      ?? customer?.institution_id?.new_pricing_contract?.full_name
      ?? customer?.institution_id?.contract?.full_name
      ?? ""

    return <td className="availability-table-cell">
      {
        fullName && formatSignedDate
          ? <>
            {fullName}
            <br/>
            {formatSignedDate}
          </> 
          : ""
      }
    </td>;
  };

  const bindSignedContractLink = (customer) => {
    const contractUrl = customer?.institution_id?.contract?.url
    const contractUpdatedUrl = customer?.institution_id?.contract_updated?.url
    const eltContractUrl = customer?.institution_id?.elt_contract?.url
    const newPricingContractUrl = customer?.institution_id?.new_pricing_contract?.url

    return (
      <td className="availability-table-cell py-1">
        {contractUrl && (
          <Link
            className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
            onClick={(event) => window.open(`/NavigateToFileViewer?fileurl=${contractUrl}`)}
            style={{ fontSize: '12px' }}
          >
            Contract
          </Link>
        )}
        {contractUpdatedUrl && (
          <Link
            className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
            onClick={(event) => window.open(`/NavigateToFileViewer?fileurl=${contractUpdatedUrl}`)}
            style={{ fontSize: '12px' }}
          >
            Updated Contract
          </Link>
        )}
        {eltContractUrl && (
          <Link
            className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
            onClick={(event) => window.open(`/NavigateToFileViewer?fileurl=${eltContractUrl}`)}
            style={{ fontSize: '12px' }}
          >
            ELT Updated Contract
          </Link>
        )}
        {newPricingContractUrl && (
          <Link
            className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
            onClick={(event) => window.open(`/NavigateToFileViewer?fileurl=${newPricingContractUrl}`)}
            style={{ fontSize: '12px' }}
          >
            New Pricing Contract
          </Link>
        )}
      </td>
    );
  };


  const onDetailsClicked = async (customer) => {
    const user = { ...customer };
    user.role = "customer";

    const college = await populateCollegeData(customer.institution_id);
    college.user = user;

    updateCurrentCollegeDetails(college);
    history.push("/CollegeDetails");
  };

  const onHyperLinkClicked = async (customer) => {
    const user = { ...customer };
    user.role = "customer";

    const college = await populateCollegeData(customer.institution_id);
    college.user = user;

    updateCurrentCollegeDetails(college);
    history.push("/CollegeDetailCalendar");
  };

    const bindCalendarLink = (customer) => {
      return(
        <td className="availability-table-cell">
          {customer.institution_id?._id && (
            <Link
              className="mdi mdi-timetable home-icon-margin-adjust profile-link"
              title="Nav Inst Calendar"
              onClick={() => onHyperLinkClicked(customer)}
            >
            </Link>
          )}
        </td>
      )}

  const bindMoreDetailsLink = (customer) => {
    return (
      <td className="availability-table-cell">
        {customer.institution_id?._id && (
          <Link
            className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
            onClick={(event) => onDetailsClicked(customer)}
          >
            More Details
          </Link>
        )}
      </td>
    );
  };

  const bindUniCheckbox = (customer) => {
    return (
      <td className="availability-table-cell">
        {customer.institution_id?._id && (
          <CheckableButton
            checkbox
            noBorder
            // id={"type" + customer.institution_id.inst_type}
            checked={customer.institution_id.inst_type === "UNI"}
            onChange={(e) => {
              const type = e.target.checked ? "UNI" : "NON-UNI";
              updateInstType(customer.institution_id._id, type)
            }}
          />
        )}
      </td>
    );
  };

  const bindGroupDropdownList = (customer) => {
    return (
      <td className="availability-table-cell">
        {customer.institution_id?._id && (
          <FormDropdown
            id="group"
            className=''
            placeholder='Group'
            required
            onChange={(e) => {
              const group_type = e.target.value;
              setGroup(group_type);
              setInstitutionId(customer.institution_id._id);
              setShowConfirmChangeGroupPopup(true)
            }}
            value={customer.institution_id?.group}
          >
            <option value=''>
              ---
            </option>
            <option selected={customer.institution_id.group_type === 'A'} value='A'>
              A
            </option>
            <option selected={customer.institution_id.group_type === 'B'} value="B">
              B
            </option>
          </FormDropdown>
        )}
      </td>
    );
  }

  const bindCampusStatesData = (customer) => {
    const allStates = customer?.institution_id?.campuses_detail?.map(item => item.state);
    const uniqueStates = [...new Set(allStates)];
    const statesStr = uniqueStates.join(', ')
    return (
      <td className="availability-table-cell">
        {statesStr}
      </td>
    );
  }

  const bindLatestBookingData = (customer) => {
    const latestBooking = customer?.latest_booking
    const latestBookingTime = latestBooking?.[0]?.createdAt
    const formattedBookingTime = latestBookingTime ? moment(latestBookingTime).format("YYYY-MM-DD") : ""

    return (
      <td className="availability-table-cell">
        {formattedBookingTime}
      </td>
    );
  }

  const updateGroupCollege = (inst_id, group) => {
    if(inst_id) {
      API.setInstitutionGroup(inst_id, group).then(res => {
        const newAllUsers = allCustomers.map((customer) => {
          if (customer.institution_id._id === inst_id) {
            customer.institution_id.group = group
          }
          return customer
        })
        setAllCustomers(newAllUsers)
        notify.show("Institution Group updated successfully")
      }).catch(err => {
        notify.show("Error Updating institution group")
        console.log(err)
      })
    }
  }

  const updateInstType = (inst_id, type) => {
    API.updateInstType(inst_id, type).then(res => {
      const newAllUsers = allCustomers.map((customer) => {
        if (customer.institution_id._id === inst_id) {
          customer.institution_id.inst_type = type
        }
        return customer
      })
      // console.log(newAllUsers)
      setAllCustomers(newAllUsers)
      notify.show("Institution type updated successfully")
    }).catch(err => {
      notify.show("Error Updating institution type")
      console.log(err)
    })
  }

  return (
    <AdminWrapper>
      <Fragment>
        <SwitchMenuBar isViewAsTeacher />
        <div className="page-container-main bg-photoregister">
          <div className="bg-gradient page-container-bg"></div>
          <div className="page-container-header">
            <div className="page-container-header-inner">
              <div className="d-flex flex-row align-items-center">
                <div className="p-2">
                  <h1>Manage Colleges</h1>
                </div>
                <div className="p-2">
                  <SearchBar
                    placeholder="Search by Keyword"
                    onChange={searchByName}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="page-container-inner">
            <div className="availability-table-body">
              <div className="availability-table-body-content overflow-auto">
                <table className="av-tab-root">
                  <thead className="availability-table-head">
                    <tr className="availability-table-head-row">
                      {buildTableHeader("Institution Name")}
                      {buildTableHeader("Contact Name")}
                      {buildTableHeader("Contact Email")}
                      {buildTableHeader("Contact Number")}
                      {buildTableHeader("Last booking")}
                      {buildTableHeader("Owner campus state")}
                      {buildTableHeader("Profile")}
                      {buildTableHeader("HyperLink")}
                      {buildTableHeader("Details")}
                      {buildTableHeader("Uni?")}
                      {buildTableHeader("Group")}
                      {buildTableHeader("Signed Contract Info")}
                      {buildTableHeader("Signed Contract Link")}
                    </tr>
                  </thead>
                  <tbody className="availability-table-body-bodytable">
                    {customersOfCurrPage.map((customer, index) => (
                      <tr key={index} className="availability-table-body-row">
                        {bindTableData(customer.institution_name)}
                        {bindTableDataWithId(
                          customer._id,
                          customer._id,
                          getContactName(
                            customer.first_name,
                            customer.last_name
                          )
                        )}
                        {bindTableData(customer.email)}
                        {bindTableData(customer.mobile)}
                        {bindLatestBookingData(customer)}
                        {bindCampusStatesData(customer)}
                        {bindProfileLink(customer)}
                        {bindCalendarLink(customer)}
                        {bindMoreDetailsLink(customer)}
                        {bindUniCheckbox(customer)}
                        {bindGroupDropdownList(customer)}
                        {bindContractSignedInfoData(customer)}
                        {bindSignedContractLink(customer)}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="row bookings-bottom pb-0">
                <div className="col-lg-3 col-md-0 "></div>
                <div className="col-lg-6  col-md-12 bookings-bottom-pagination">
                  <Responsive minWidth={1500}>
                    <Pagination
                      totalPages={totalPages}
                      siblingRange={1}
                      ellipsisItem={false}
                      firstItem={false}
                      lastItem={false}
                      onPageChange={(e) => onPageNumChange(e)}
                      activePage={pageNum}
                    />
                  </Responsive>
                  <Responsive minWidth={1200} maxWidth={1499}>
                    <Pagination
                      totalPages={totalPages}
                      ellipsisItem={false}
                      firstItem={false}
                      lastItem={false}
                      boundaryRange={0}
                      siblingRange={1}
                      onPageChange={(e) => onPageNumChange(e)}
                      activePage={pageNum}
                    />
                  </Responsive>
                  <Responsive maxWidth={1199}>
                    <Pagination
                      totalPages={totalPages}
                      ellipsisItem={false}
                      firstItem={false}
                      lastItem={false}
                      boundaryRange={0}
                      siblingRange={0}
                      onPageChange={(e) => onPageNumChange(e)}
                      activePage={pageNum}
                    />
                  </Responsive>
                  {
                    showConfirmChangeGroupPopup && (
                      <Modal
                        show={true}
                        header="Update Group Status"
                        className="export-booking-modal"
                        onClose={() => {
                          setShowConfirmChangeGroupPopup(false);
                        }}
                      >
                        <div className="row d-flex justify-content-center">
                          <div className="col-md-10 text-center">
                          Do you want to do this action?
                          </div>
                          <div className="mt-5 col-md-8 d-flex justify-content-center">
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                updateGroupCollege(institutionId, group);
                                setShowConfirmChangeGroupPopup(false);
                              }}
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </Modal>
                    )
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </AdminWrapper>
  );
};

const mapDispatchToProps = (dispatch) => ({
  updateCurrentCollegeDetails: (colleges) =>
    dispatch(updateCurrentCollegeDetails(colleges)),
});

export default connect(null, mapDispatchToProps)(AllColleges);
